import { CircularProgress } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as api from "./billCollection.service";

// Format date as IST
const formatIST = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return (
    d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "Asia/Kolkata",
    }) + " IST"
  );
};

// Determine status type from keywords
const getStatusType = (str) => {
  const s = (str || "").toLowerCase();
  if (s.includes("reject") || s.includes("declined")) return "rejected";
  if (s.includes("approved") || s.includes("approve")) return "approved";
  if (s.includes("pending")) return "pending";
  if (s.includes("mismatch")) return "mismatch";
  return "info";
};

const CollectionHistory = ({ appointmentId }) => {
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);

  const fetchHistory = useCallback(async () => {
    if (!appointmentId) return;
    setLoading(true);
    try {
      const res = await api.getCollectionStatusHistory(appointmentId);
      const rows = res?.data || [];
      const mapped = rows.map((row) => ({
        title: row.tag || row.status || "",
        statusLabel: row.status || "",
        statusType: getStatusType(row.tag || row.status),
        remarks: row.remarks || "",
        by: [row.addedByUsername, row.source].filter(Boolean).join(" (") +
          (row.source ? ")" : ""),
        timestamp: formatIST(row.addedAt),
        collectionLoss: row.collectionLoss,
        lossType: row.lossType,
      }));
      setEvents(mapped);
    } catch {
      toast.error("Failed to load collection history");
    } finally {
      setLoading(false);
    }
  }, [appointmentId]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  if (loading) {
    return (
      <div className="cbc-loading">
        <CircularProgress size={24} />
      </div>
    );
  }

  if (events.length === 0) {
    return <div className="cbc-empty">No collection history yet.</div>;
  }

  return (
    <div className="cbc-timeline">
      {events.map((evt, i) => (
        <div className={`cbc-timeline-item ${evt.statusType}`} key={i}>
          <div className="cbc-timeline-title">{evt.title}</div>
          <div className="cbc-timeline-meta">
            {evt.by && <span>{evt.by}</span>}
            {evt.timestamp && <span> · {evt.timestamp}</span>}
          </div>
          {evt.statusLabel && (
            <span
              className={`cbc-pill ${
                evt.statusType === "approved"
                  ? "green"
                  : evt.statusType === "rejected"
                  ? "red"
                  : evt.statusType === "pending"
                  ? "yellow"
                  : "gray"
              }`}
              style={{ marginTop: 4 }}
            >
              {evt.statusLabel}
            </span>
          )}
          {evt.remarks && (
            <div className="cbc-timeline-remarks">{evt.remarks}</div>
          )}
          {evt.collectionLoss && (
            <div className="cbc-timeline-remarks">
              Loss: ₹{evt.collectionLoss}
              {evt.lossType ? ` (${evt.lossType})` : ""}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CollectionHistory;
